<app-header></app-header>

<div class="container mx-auto px-4 py-8 max-w-4xl">
  <!-- Status Banner -->
  <div *ngIf="meeting" class="mb-6">
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 p-4 rounded-lg shadow-sm"
         [ngClass]="getStatusClasses()">
      <div class="flex items-center gap-3">
        <div class="w-3 h-3 rounded-full" [ngClass]="getStatusDotClasses()"></div>
        <h2 class="text-xl font-semibold">{{ meeting?.name }}</h2>
        <span class="px-2 py-1 text-xs font-medium rounded-full bg-white bg-opacity-30">
          {{ meeting?.visitor_type | titlecase }}
        </span>
      </div>

      <div *ngIf="meeting?.status === 'ENDED' || meeting?.status === 'REJECTED'"
           class="flex items-center gap-2">
        <span class="text-sm font-medium">{{ isExpired ? 'Expired' : 'Expiring in' }}</span>
        <div class="px-3 py-1 font-medium rounded-lg text-sm"
             [ngClass]="isExpired ? 'bg-white text-red-800' : 'bg-red-800 text-white'">
          {{ isExpired ? '!' : remainingTime }}
        </div>
      </div>
    </div>
  </div>

  <!-- Meeting Details Card -->
  <div *ngIf="meeting" class="bg-white rounded-xl shadow-md overflow-hidden">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 p-6">
      <!-- Visitor Image -->
      <div class="md:col-span-1 flex flex-col items-center">
        <div class="w-48 h-48 rounded-full overflow-hidden border-4 border-gray-100 shadow-md mb-4">
          @if (meeting?.file?.partial_url) {
            <img [src]="environment.s3_bucket_url + meeting?.file?.partial_url"
                 class="w-full h-full object-cover"
                 alt="Visitor image">
          } @else {
            <img src="../../../../../../../assets/images/visitor-image-icon.png"
                 class="w-full h-full object-cover"
                 alt="Default visitor image">
          }
        </div>
        <div class="text-center">
          <h3 class="text-lg font-semibold text-gray-800">{{ meeting?.name }}</h3>
          <p class="text-sm text-gray-500">{{ meeting?.visitor_type | titlecase }}</p>
        </div>
      </div>

      <!-- Meeting Information -->
      <div class="md:col-span-2">
        <h3 class="text-xl font-bold text-gray-800 mb-4 pb-2 border-b">Meeting Details</h3>

        <div class="space-y-4">
          <!-- Meeting ID -->
          <div class="flex items-center">
            <div class="w-1/3 text-gray-600 font-medium">
              <i class="fas fa-id-badge mr-2 text-blue-500"></i>
              Meeting ID
            </div>
            <div class="w-2/3 text-gray-800 font-semibold">
              {{ meeting?.meeting_id }}
            </div>
          </div>

          <!-- Meeting Person -->
          <div class="flex items-center">
            <div class="w-1/3 text-gray-600 font-medium">
              <i class="fas fa-user mr-2 text-green-500"></i>
              Meeting With
            </div>
            <div class="w-2/3 text-gray-800">
              {{ meeting?.meeting_person?.employee?.name }}
            </div>
          </div>

          <!-- Department -->
          <div class="flex items-center">
            <div class="w-1/3 text-gray-600 font-medium">
              <i class="fas fa-building mr-2 text-purple-500"></i>
              Department
            </div>
            <div class="w-2/3 text-gray-800">
              {{ meeting?.meeting_person?.department?.name }}
            </div>
          </div>

          <!-- Status -->
          <div class="flex items-center">
            <div class="w-1/3 text-gray-600 font-medium">
              <i class="fas fa-info-circle mr-2" [ngClass]="getStatusIconClasses()"></i>
              Status
            </div>
            <div class="w-2/3">
              <span class="px-3 py-1 rounded-full text-sm font-medium" [ngClass]="getStatusBadgeClasses()">
                {{ meeting?.status }}
              </span>
            </div>
          </div>

          <!-- Time Information -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 pt-4 border-t">
            <div class="flex flex-col">
              <div class="text-gray-600 font-medium mb-1">
                <i class="fas fa-clock mr-2 text-indigo-500"></i>
                Start Time
              </div>
              <div class="text-gray-800 font-medium">
                {{ (meeting?.meeting_start_time | date : 'shortTime') || '-' }}
              </div>
            </div>

            <div class="flex flex-col">
              <div class="text-gray-600 font-medium mb-1">
                <i class="fas fa-clock mr-2 text-indigo-500"></i>
                End Time
              </div>
              <div class="text-gray-800 font-medium">
                {{ (meeting?.meeting_end_time | date : 'shortTime') || '-' }}
              </div>
            </div>
          </div>

          <!-- Additional Persons -->
          <div *ngIf="meeting?.persons && JSON.parse(meeting?.persons).length > 0"
               class="mt-4 pt-4 border-t">
            <div class="text-gray-600 font-medium mb-2">
              <i class="fas fa-users mr-2 text-amber-500"></i>
              Additional Persons
            </div>
            <div class="flex flex-wrap gap-2">
              <span *ngFor="let person of JSON.parse(meeting?.persons)"
                    class="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">
                {{ person?.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
